<template>
  <v-button
    class="navbar-search__open"
    label="Toggle Search"
    @click="toggleSearch"
    v-if="showSearch === false || $mq === 'mobile'"
    aria-label="Open Search"
  >
    <icon name="search" size="24px" class="navbar-search-icon"></icon>
  </v-button>
  <span v-else>
    <div class="navbar-search">
      <div class="navbar-search__wrapper">
        <search-form
          class="navbar-search__form"
          @close-search="closeSearch"
          search-icon-size="18"
          :enablePredictiveSearch="enablePredictiveSearch"
          input-placeholder="What are you looking for?"
        ></search-form>
      </div>
    </div>
  </span>
</template>

<script>
import SearchForm from '@/scripts/components/forms/SearchForm.vue'
import VButton from '@/scripts/components/buttons/VButton.vue'
import Icon from '@/scripts/components/basic/Icon.vue'

export default {
  name: 'NavbarSearch',
  components: { SearchForm, VButton, Icon },
  props: {
    enablePredictiveSearch: Boolean
  },
  data () {
    return {
      showSearch: false
    }
  },
  methods: {
    openSearch () {
      this.showSearch = true
    },
    closeSearch () {
      this.showSearch = false
    },
    toggleSearch () {
      if (this.showSearch) {
        this.closeSearch()
      } else {
        this.openSearch()
      }
      this.$emit('toggle-search')
    }
  }
}
</script>

<style scoped lang="scss">
.navbar-search {
  position: relative;
  right: 0;
  display: block;
  width: 224px;
  height: 43px;
  color: $color-white;
  &__open {
    margin-left: auto;
  }

  &__wrapper {
    max-width: 100%;
    margin: auto;
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    min-height: 100vh;
    z-index: 9999;
    background-color: $color-white-tea-400;
  }

  &__form {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    min-height: 100vh;
    z-index: 99999;
    overflow-y: auto;
    align-items: start;
    padding-left: 93px;
    padding-right: 157px;
    max-width: 1440px;
    margin: auto;
    background-color: transparent;

    /deep/ .search-input {
      margin-top: 71px;
      background: transparent;
      border: none;
      border-bottom: 1px solid;
      border-radius: 0;
    }

    /deep/ .search-form__submit {
      top: 93px;
      left: 93px;
    }

    /deep/ .search-form__close {
      top: 93px;
      right: 93px;
    }

    /deep/ .icon--close {
      width: 20px !important;
      height: 20px !important;
    }
  }
}
.navbar-search-icon {
  max-width: 19px;
  max-height: 18px;
}
</style>
